webpackJsonp([43,122,279],{

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isActive: true
        };
    }
});

/***/ }),

/***/ 1111:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-menu', [_c('b-menu-list', {
    attrs: {
      "label": "Menu"
    }
  }, [_c('b-menu-item', {
    attrs: {
      "icon": "information-outline",
      "label": "Info"
    }
  }), _vm._v(" "), _c('b-menu-item', {
    attrs: {
      "icon": "settings",
      "active": _vm.isActive,
      "expanded": _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.isActive = !_vm.isActive
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function(props) {
        return [_vm._v("\n                    Administrator\n                    "), _c('b-icon', {
          staticClass: "is-pulled-right",
          attrs: {
            "icon": props.expanded ? 'menu-down' : 'menu-up'
          }
        })]
      }
    }])
  }, [_c('b-menu-item', {
    attrs: {
      "icon": "account",
      "label": "Users"
    }
  }), _vm._v(" "), _c('b-menu-item', {
    attrs: {
      "icon": "cellphone-link"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function(props) {
        return [_vm._v("\n                        Devices\n                        "), _c('b-dropdown', {
          staticClass: "is-pulled-right",
          attrs: {
            "aria-role": "list",
            "position": "is-bottom-left"
          }
        }, [_c('b-icon', {
          attrs: {
            "slot": "trigger",
            "icon": "dots-vertical"
          },
          slot: "trigger"
        }), _vm._v(" "), _c('b-dropdown-item', {
          attrs: {
            "aria-role": "listitem"
          }
        }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
          attrs: {
            "aria-role": "listitem"
          }
        }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
          attrs: {
            "aria-role": "listitem"
          }
        }, [_vm._v("Something else")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('b-menu-item', {
    attrs: {
      "icon": "cash-multiple",
      "label": "Payments",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('b-menu-item', {
    attrs: {
      "icon": "account",
      "label": "My Account"
    }
  }, [_c('b-menu-item', {
    attrs: {
      "label": "Account data"
    }
  }), _vm._v(" "), _c('b-menu-item', {
    attrs: {
      "label": "Addresses"
    }
  })], 1)], 1), _vm._v(" "), _c('b-menu-list', [_c('b-menu-item', {
    attrs: {
      "label": "Expo",
      "icon": "link",
      "tag": "router-link",
      "target": "_blank",
      "to": "/expo"
    }
  })], 1), _vm._v(" "), _c('b-menu-list', {
    attrs: {
      "label": "Actions"
    }
  }, [_c('b-menu-item', {
    attrs: {
      "label": "Logout"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_menu__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_menu__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default.a
        };
    }
});

/***/ }),

/***/ 1425:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-menu>\n        <b-menu-list label=\"Menu\">\n            <b-menu-item icon=\"information-outline\" label=\"Info\"></b-menu-item>\n            <b-menu-item\n                icon=\"settings\"\n                :active=\"isActive\"\n                :expanded=\"isActive\"\n                @click=\"isActive = !isActive\">\n                <template slot=\"label\" slot-scope=\"props\">\n                    Administrator\n                    <b-icon\n                        class=\"is-pulled-right\"\n                        :icon=\"props.expanded ? 'menu-down' : 'menu-up'\">\n                    </b-icon>\n                </template>\n                <b-menu-item icon=\"account\" label=\"Users\"></b-menu-item>\n                <b-menu-item icon=\"cellphone-link\">\n                    <template slot=\"label\" slot-scope=\"props\">\n                        Devices\n                        <b-dropdown aria-role=\"list\" class=\"is-pulled-right\" position=\"is-bottom-left\">\n                        <b-icon icon=\"dots-vertical\" slot=\"trigger\"></b-icon>\n                            <b-dropdown-item aria-role=\"listitem\">Action</b-dropdown-item>\n                            <b-dropdown-item aria-role=\"listitem\">Another action</b-dropdown-item>\n                            <b-dropdown-item aria-role=\"listitem\">Something else</b-dropdown-item>\n                        </b-dropdown>\n                    </template>\n                </b-menu-item>\n                <b-menu-item icon=\"cash-multiple\" label=\"Payments\" disabled></b-menu-item>\n            </b-menu-item>\n            <b-menu-item icon=\"account\" label=\"My Account\">\n                <b-menu-item label=\"Account data\"></b-menu-item>\n                <b-menu-item label=\"Addresses\"></b-menu-item>\n            </b-menu-item>\n        </b-menu-list>\n        <b-menu-list>\n            <b-menu-item\n                label=\"Expo\"\n                icon=\"link\"\n                tag=\"router-link\"\n                target=\"_blank\"\n                to=\"/expo\">\n            </b-menu-item>\n        </b-menu-list>\n        <b-menu-list label=\"Actions\">\n            <b-menu-item label=\"Logout\"></b-menu-item>\n        </b-menu-list>\n    </b-menu>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                isActive: true\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1426:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    title: 'Menu',
    props: [{
        name: '<code>accordion</code>',
        description: 'Close automatically the previous selected menu list',
        type: 'Boolean',
        values: '—',
        default: 'true'
    }],
    slots: [{
        name: 'default',
        description: 'Menu list elements',
        props: '—'
    }]
}, {
    title: 'Menu List',
    props: [{
        name: '<code>label</code>',
        description: 'Menu list label',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>icon</code>',
        description: 'Icon name',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>icon-pack</code>',
        description: 'Icon pack to use',
        type: 'String',
        values: '—',
        default: '<code>mdi</code>'
    }, {
        name: '<code>aria-role</code>',
        description: 'Role attribute to be passed to list container for better accessibility. Use <code>menu</code> only in situations where your dropdown is really related to navigation.',
        type: 'String',
        values: '<code>menu</code>',
        default: '—'
    }],
    slots: [{
        name: 'default',
        description: 'Menu item elements',
        props: '—'
    }, {
        name: '<code>label</code>',
        description: 'Menu list custom label',
        props: '—'
    }]
}, {
    title: 'Menu Item',
    props: [{
        name: '<code>label</code>',
        description: 'Menu item label',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>icon</code>',
        description: 'Icon name',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>icon-pack</code>',
        description: 'Icon pack to use',
        type: 'String',
        values: '—',
        default: '<code>mdi</code>'
    }, {
        name: '<code>disabled</code>',
        description: 'Item is disabled',
        type: 'Boolean',
        values: '-',
        default: 'false'
    }, {
        name: '<code>active</code>',
        description: 'Item is active, use the .sync modifier to make it two-way binding',
        type: 'Boolean',
        values: '-',
        default: 'false'
    }, {
        name: '<code>expanded</code>',
        description: 'Item is expanded when <code>default</code> contains menu items, use the .sync modifier to make it two-way binding',
        type: 'Boolean',
        values: '-',
        default: 'false'
    }, {
        name: '<code>animation</code>',
        description: 'Custom animation (transition name)',
        type: 'String',
        values: '—',
        default: '<code>fade</code>'
    }, {
        name: '<code>tag</code>',
        description: 'Button tag name',
        type: 'String',
        values: '<code>a</code>, <code>router-link</code>, <code>nuxt-link</code> or other nuxt alias',
        default: '<code>a</code>'
    }, {
        name: '<code>aria-role</code>',
        description: 'Role attribute to be passed to list item for better accessibility. Use <code>menuitem</code> only in situations where your menu item is really related to navigation.',
        type: 'String',
        values: '<code>menuitem</code>',
        default: '—'
    }, {
        name: 'Any native attribute',
        description: '—',
        type: '—',
        values: '—',
        default: '—'
    }],
    events: [{
        name: '<code>click</code>',
        description: 'Triggers on click',
        parameters: '<code>event: $event</code>'
    }],
    slots: [{
        name: 'default',
        description: 'Menu item body',
        props: '—'
    }, {
        name: '<code>label</code>',
        description: 'Menu list custom label',
        props: '<code>active: Boolean</code>,<code>expanded: Boolean</code>'
    }]
}]);

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1110),
  /* template */
  __webpack_require__(1111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1424),
  /* template */
  __webpack_require__(1426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/43.58864db79b73151fee3b.js